import { useCallback, useContext, useMemo } from "react";

import { MapSettingsContext } from "./map-settings-context";

interface SelectedMarker {
  value: string;
  layerId?: string;
}

const useSelectedMarker = () => {
  const { settings, setSetting } = useContext(MapSettingsContext);

  const setSelectedMarker = useCallback(
    (value: string, layerId?: string) => {
      if (!setSetting) return;
      setSetting("selectedMarker", {
        value,
        layerId,
      });
    },
    [settings, setSetting],
  );

  const resetSelectedMarker = useCallback(() => {
    if (!setSetting) return;
    setSetting("selectedMarker", undefined);
  }, [setSetting]);

  const selectedMarker = useMemo(() => {
    if (!settings?.selectedMarker) return undefined;
    return settings.selectedMarker as SelectedMarker;
  }, [settings]);

  const all = useMemo(
    () => ({
      selectedMarker,
      setSelectedMarker,
      resetSelectedMarker,
    }),
    [selectedMarker, setSelectedMarker, resetSelectedMarker],
  );

  return all;
};

export default useSelectedMarker;
